import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEOHead from '../../components/SEOHead';
import { LEARN_POSTS } from '../../data/seoRetrofitData';

export default function LearnHubPage() {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="learn-hub-page">
      <SEOHead
        title="Learn Asset Finance Australia | Flash Funding"
        description="Long-form guides for Australian SMB operators on asset finance, truck lending, equipment funding, and business cashflow structures."
        canonical="/learn"
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="learn-hub-main-section">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-4">Learn</h1>
        <p className="text-white/70 text-sm sm:text-base mb-8">Practical long-form guides for Australian SMB operators evaluating finance structures and lender pathways.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="learn-hub-grid">
          {LEARN_POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/learn/${post.slug}`}
              className="rounded-2xl border border-purple-500/20 bg-navy-800/70 p-5 hover:border-purple-400/45"
              data-testid={`learn-hub-post-link-${post.slug}`}
            >
              <h2 className="text-xl font-semibold text-white mb-2">{post.title}</h2>
              {post.description && <p className="text-white/65 text-sm mb-4">{post.description}</p>}
              <span className="inline-flex items-center gap-1 text-sm text-purple-300">Read guide <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
